import React from 'react';
import styles from './InteractiveImportRowCellPlaceholder.css';

function InteractiveImportRowCellPlaceholder() {
  return (
    <span className={styles.placeholder} />
  );
}

export default InteractiveImportRowCellPlaceholder;
